import React from 'react';
import { Link } from 'react-router-dom';

export function CheckoutFailurePage() {
    return (
        <div className="page-user">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-10 col-xl-8">
                        <div className="card content-area">
                            <div className="card-innr">
                                <div className="status status-canceled px-md-5">
                                    <div className="status-icon">
                                        <em className="ti ti-close" />
                                    </div>
                                    <span className="status-text large text-dark">The last transaction was unsuccessful</span>
                                    <p className="px-md-5">Please contact admin to resolve any issue.</p>
                                </div>
                            </div>
                        </div>{/* .card */}
                        <div className="gaps-1x" />
                        <div className="gaps-3x d-none d-sm-block" />
                    </div>
                </div>
            </div>{/* .container */}
        </div>
    )
}